import React, { useEffect, useState } from 'react'
import { facebook_url, telegram_url, twitter_url, whatsapp_url } from '../../utils/Enviroment'
import { userProfileData } from '../RecoilAtom'
import { useRecoilValue } from 'recoil'
import { shareRiskMarketPnLtoEmail, shareRiskMarketPnLtoSocials } from '../../utils/helpers'
import useCrashDataFetcher from '../../hooks/dataFetcher/useCrashDataFetcher'
import { useTranslation } from 'react-i18next'

const ShareCrash = ({ smartAccount, percentage, exposureAmount, realizedPnl }) => {
    const {t} = useTranslation();
    const userProfile = useRecoilValue(userProfileData);
    const userIdentity = userProfile?.name || null;
    const { getCrashGameIndex } = useCrashDataFetcher();

    const [gameIndex, setGameIndex] = useState(null);
    const [isCopied, setIsCopied] = useState(false);

    // ✅ PREFETCH async data BEFORE click
    useEffect(() => {
        getCrashGameIndex().then(setGameIndex);
    }, [getCrashGameIndex]);

    // 🚫 if data not ready yet, do nothing
    const buildPayload = () => {
        if (!gameIndex) return null;

        return {
            userId: userProfile?._id,
            name: userIdentity,
            walletAddress: smartAccount,
            percentage: `${percentage}%`,
            exposureAmount,
            realizedPnl,
            transactionHash: `${smartAccount}${gameIndex}`,
            profileImageUrl: userProfile?.profilePic
        };
    };

    // ✅ PURE SYNC — iOS SAFE
    const handleSocialShare = (url) => {
        const payload = buildPayload();
        if (!payload) return;

        shareRiskMarketPnLtoSocials({
            url,
            ...payload
        });
    };

    // ✅ PURE SYNC — clipboard works on iOS
    const handleCopy = () => {
        const payload = buildPayload();
        if (!payload) return;

        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 1000);

        shareRiskMarketPnLtoEmail({
            ...payload,
            isCopyToClipboard: true
        });
    };

    // email is allowed async
    const handleEmail = async () => {
        const payload = buildPayload();
        if (!payload) return;

        await shareRiskMarketPnLtoEmail({
            ...payload,
            isCopyToClipboard: false
        });
    };

    return (
        <>
            <div className="share-list">
                <h6>{t('Share with Friends')}</h6>
                <div className="share-icons">
                    {/* X icon */}
                    <a onClick={() => handleSocialShare(twitter_url)}><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <g clip-path="url(#clip0_8562_56772)">
                            <path d="M8.514 1.04883H10.0577L6.68513 4.9035L10.6527 10.1488H7.54613L5.11293 6.96756L2.32879 10.1488H0.784127L4.39146 6.02583L0.585327 1.04883H3.77079L5.9702 3.95663L8.514 1.04883ZM7.9722 9.22483H8.8276L3.30599 1.92429H2.38806L7.9722 9.22483Z" fill="#212121" />
                        </g>
                        <defs>
                            <clipPath id="clip0_8562_56772">
                                <rect width="11.2" height="11.2" fill="white" />
                            </clipPath>
                        </defs>
                    </svg></a>
                    {/* Facebook icon */}
                    <a onClick={() => handleSocialShare(facebook_url)}
                    ><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <g clip-path="url(#clip0_8562_56776)">
                                <path d="M6.46766 11.2V6.09153H8.18167L8.43883 4.10007H6.46766V2.82882C6.46766 2.25243 6.62706 1.85963 7.45454 1.85963L8.5082 1.85919V0.0779688C8.32599 0.0542894 7.70051 0 6.97251 0C5.45233 0 4.41159 0.927901 4.41159 2.63159V4.10007H2.69238V6.09153H4.41159V11.2H6.46766Z" fill="#212121" />
                            </g>
                            <defs>
                                <clipPath id="clip0_8562_56776">
                                    <rect width="11.2" height="11.2" fill="white" />
                                </clipPath>
                            </defs>
                        </svg></a>
                    {/* Telegram icon */}
                    <a onClick={() => handleSocialShare(telegram_url)}
                    ><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M7.73449 4.39244C8.02074 4.09768 8.30491 3.4099 7.11222 4.24506C5.99809 5.03468 4.87639 5.81292 3.74728 6.57968C3.57535 6.65972 3.38947 6.70319 3.20081 6.70741C3.01217 6.71162 2.82463 6.67654 2.64949 6.60424C1.93387 6.38317 1.09847 6.0884 1.09847 6.0884C1.09847 6.0884 0.528051 5.71942 1.5045 5.3264C1.5045 5.3264 5.63276 3.58184 7.06451 2.96722C7.61315 2.72159 9.47427 1.93555 9.47427 1.93555C9.47427 1.93555 10.3335 1.59113 10.262 2.42682C10.2381 2.77071 10.0473 3.97539 9.85644 5.27727C9.56968 7.12007 9.25958 9.13535 9.25958 9.13535C9.25958 9.13535 9.21187 9.70031 8.80636 9.79857C8.37227 9.79099 7.95286 9.63549 7.61367 9.35642C7.51825 9.28273 5.82411 8.17684 5.20339 7.63644C5.14023 7.59239 5.08895 7.53263 5.05426 7.46268C5.01962 7.39273 5.00266 7.31487 5.00504 7.23638C5.00743 7.15788 5.02905 7.08131 5.06789 7.0137C5.10673 6.94615 5.16155 6.88976 5.22725 6.84987C6.07862 6.04777 6.91449 5.22847 7.73449 4.39244Z" fill="#212121" />
                        </svg></a>
                    {/* whatsapp icon */}
                    <a onClick={() => handleSocialShare(whatsapp_url)}
                    ><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <g clip-path="url(#clip0_8562_56783)">
                                <path d="M5.59954 0.447266C2.75877 0.447266 0.447543 2.7585 0.447543 5.59927C0.447543 6.48631 0.676695 7.35856 1.11125 8.12823L0.455831 10.4668C0.434327 10.5436 0.455159 10.626 0.510711 10.6832C0.553495 10.7273 0.611735 10.7513 0.671543 10.7513C0.689463 10.7513 0.707607 10.749 0.725303 10.7448L3.16601 10.1402C3.91125 10.5403 4.75058 10.7513 5.59954 10.7513C8.44031 10.7513 10.7515 8.44003 10.7515 5.59927C10.7515 2.7585 8.44031 0.447266 5.59954 0.447266ZM8.19122 7.41725C8.08101 7.72234 7.55237 8.00077 7.29836 8.03818C7.07033 8.07155 6.78182 8.08589 6.46508 7.98643C6.27311 7.92595 6.02671 7.84576 5.71109 7.71114C4.38434 7.14531 3.51791 5.82618 3.45161 5.73904C3.38553 5.65191 2.91154 5.03098 2.91154 4.38832C2.91154 3.74567 3.25314 3.4296 3.37455 3.29879C3.49596 3.16797 3.6391 3.13527 3.72735 3.13527C3.81561 3.13527 3.90364 3.13639 3.98092 3.13997C4.06223 3.144 4.17132 3.10928 4.27861 3.36419C4.38882 3.62583 4.65337 4.26848 4.68607 4.33411C4.71922 4.39952 4.74118 4.47591 4.69727 4.56304C4.65337 4.65018 4.63141 4.70461 4.56511 4.78099C4.49881 4.85738 4.42623 4.95123 4.36665 5.00992C4.30034 5.07511 4.23157 5.14567 4.30863 5.27648C4.38569 5.4073 4.65113 5.83491 5.04447 6.18122C5.54959 6.62608 5.97586 6.76407 6.10802 6.82947C6.24018 6.89488 6.31746 6.88391 6.39452 6.79677C6.47157 6.70941 6.72514 6.4153 6.81317 6.28471C6.90121 6.15411 6.98946 6.17562 7.11087 6.2193C7.23228 6.26275 7.88255 6.57859 8.01471 6.644C8.14687 6.70941 8.23513 6.74211 8.26828 6.79655C8.30143 6.85075 8.30143 7.11239 8.19122 7.41725Z" fill="#212121" />
                            </g>
                            <defs>
                                <clipPath id="clip0_8562_56783">
                                    <rect width="11.2" height="11.2" fill="white" />
                                </clipPath>
                            </defs>
                        </svg></a>
                    {/* Email icon */}
                    <a onClick={handleEmail}
                    ><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <g clip-path="url(#clip0_8562_56786)">
                                <path d="M6.53576 6.86262C6.25712 7.04838 5.93346 7.14657 5.59976 7.14657C5.26607 7.14657 4.94241 7.04838 4.66377 6.86262L0.0743277 3.80289C0.0488652 3.78592 0.024059 3.76822 -0.000244141 3.75002V8.76371C-0.000244141 9.33854 0.46624 9.79474 1.03079 9.79474H10.1687C10.7435 9.79474 11.1997 9.32826 11.1997 8.76371V3.75C11.1754 3.76824 11.1505 3.78598 11.125 3.80298L6.53576 6.86262Z" fill="#212121" />
                                <path d="M0.43835 3.2567L5.02779 6.31644C5.20152 6.43227 5.40063 6.49017 5.59973 6.49017C5.79886 6.49017 5.99799 6.43225 6.17172 6.31644L10.7612 3.2567C11.0358 3.07372 11.1998 2.76747 11.1998 2.43693C11.1998 1.8686 10.7374 1.40625 10.1691 1.40625H1.03044C0.462128 1.40627 -0.000244141 1.86862 -0.000244141 2.43748C-0.000244141 2.76747 0.163731 3.07372 0.43835 3.2567Z" fill="#212121" />
                            </g>
                            <defs>
                                <clipPath id="clip0_8562_56786">
                                    <rect width="11.2" height="11.2" fill="white" />
                                </clipPath>
                            </defs>
                        </svg></a>
                    {/* Copy Link icon */}
                    <a onClick={handleCopy}

                    >
                        {isCopied ? <svg className="copysvg" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M13 3L4.75 11L1 7.36364" stroke="#E6FF00" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> : <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <g clip-path="url(#clip0_8562_56790)">
                                <path d="M6.83369 4.36677C6.70102 4.23331 6.55391 4.11501 6.3951 4.01403C5.97448 3.74469 5.48549 3.60157 4.98602 3.60157C4.29277 3.60028 3.62769 3.87572 3.13835 4.36677L0.764374 6.7426C0.275862 7.23206 0.00129245 7.89521 0.000855033 8.58673C-6.3552e-05 10.0298 1.16899 11.2003 2.61204 11.2013C3.30422 11.2037 3.96868 10.9295 4.45785 10.4398L6.4175 8.48015C6.45311 8.44485 6.47299 8.39669 6.4727 8.34656C6.47211 8.24348 6.38806 8.16042 6.28498 8.16101H6.21034C5.80091 8.16245 5.39514 8.08382 5.01589 7.92959C4.94601 7.90083 4.8657 7.91706 4.81247 7.97064L3.40338 9.38159C2.96583 9.81914 2.25642 9.81914 1.81887 9.38159C1.38131 8.94403 1.38131 8.23462 1.81887 7.79707L4.20218 5.41564C4.63938 4.97899 5.34763 4.97899 5.78484 5.41564C6.07948 5.69294 6.53908 5.69294 6.83371 5.41564C6.96047 5.28877 7.03733 5.12049 7.05021 4.94159C7.06383 4.7278 6.98499 4.51842 6.83369 4.36677Z" fill="#212121" />
                                <path d="M10.4345 0.765329C9.41406 -0.25511 7.7596 -0.25511 6.73916 0.765329L4.78137 2.72124C4.72761 2.77526 4.71211 2.85651 4.74218 2.92654C4.7719 2.99677 4.84136 3.04184 4.91761 3.04038H4.98665C5.3956 3.03964 5.80072 3.11887 6.17924 3.27368C6.24912 3.30244 6.32943 3.28621 6.38266 3.23263L7.78801 1.82914C8.22556 1.39158 8.93497 1.39158 9.37252 1.82914C9.81008 2.26669 9.81008 2.9761 9.37252 3.41365L7.6219 5.1624L7.60696 5.17919L6.99481 5.78763C6.55761 6.22428 5.84936 6.22428 5.41215 5.78763C5.11751 5.51032 4.65791 5.51032 4.36328 5.78763C4.23571 5.91546 4.15879 6.0852 4.14678 6.2654C4.13313 6.47919 4.21198 6.68856 4.36328 6.84024C4.5793 7.05718 4.83205 7.23409 5.10981 7.3628C5.149 7.38146 5.1882 7.3964 5.22739 7.41319C5.26658 7.42999 5.30763 7.44305 5.34683 7.45798C5.38602 7.47292 5.42707 7.48598 5.46626 7.49718L5.57638 7.52703C5.65103 7.54569 5.7257 7.56063 5.8022 7.57368C5.89437 7.58737 5.98719 7.5961 6.08029 7.59982H6.21093H6.22213L6.33411 7.58676C6.37516 7.5849 6.41809 7.57556 6.46662 7.57556H6.53007L6.65885 7.55691L6.71858 7.54571L6.82682 7.52331H6.84736C7.3058 7.40816 7.72441 7.1708 8.0586 6.8365L10.4344 4.46066C11.4549 3.44023 11.4549 1.78577 10.4345 0.765329Z" fill="#212121" />
                            </g>
                            <defs>
                                <clipPath id="clip0_8562_56790">
                                    <rect width="11.2" height="11.2" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>}
                    </a>
                </div>
            </div>
        </>
    )
}

export default ShareCrash